<!--    聯絡我們-->
<template>
    <div>
        <vs-row vs-type="flex" vs-align="center">
            <vs-col vs-w="6">
                <span :class="isMobile() ? 'titleMob' : 'title'">{{$t('message.contactUs')}}</span>
            </vs-col>
            <vs-col vs-w="6" vs-type="flex" vs-justify="flex-end">
            </vs-col>
        </vs-row>
        <vs-row>
            <vs-col vs-w="2" vs-sm="0"></vs-col>
            <vs-col vs-w="8" vs-sm="12">
                <vs-card class="card-con">
                    <vs-input :placeholder="$t('message.name')" v-model="name" style="width: 50%;"></vs-input>
                    <vs-input :placeholder="$t('message.email')" v-model="email" style="width: 50%;" ></vs-input>
                    <vs-input :placeholder="$t('message.subject')" v-model="subject" style="width: 100%;"></vs-input>

                    <textarea :placeholder="$t('message.content')" v-model="message" style="margin-bottom: 15px" class="vs-input--input textArea"></textarea>

                    <vs-row vs-type="flex" vs-justify="center">
                        <vs-button size="small" color="rgb(37, 105, 193)" @click="onContactUs()">{{$t('message.send')}}</vs-button>
                    </vs-row>

                </vs-card>
            </vs-col>
            <vs-col vs-w="2" vs-sm="0"></vs-col>
        </vs-row>




    </div>
</template>

<script>
    export default {
        beforeRouteEnter(to,from,next){
            if($cookies.get('role') == 'user'){
                next()
            }else if($cookies.get('role') == 'agent'){
                next('/customer')
            }else if($cookies.get('role') == 'admin'|| $cookies.get('role') == 'manager'){
                next('/account_staff')
            }
        },
        data() {
            return {
                token:'',
                name:'',
                email:'',
                subject:'',
                message:''
            }
        },
        created() {
            this.token = this.$cookies.get('token');

        },
        methods: {
            onContactUs(){
                let url = process.env.VUE_APP_API_BASEURL + '/api/enquiry?access_token=' + this.token;
                fetch(url,{
                    method: 'post',
                    headers: {
                        'Accept': 'application/json, text/plain, *!/!*',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        name:this.name,
                        email:this.email,
                        subject:this.subject,
                        message:this.message
                    })
                }).then((response)=>{
                    return response.json()
                }).then((res)=>{
                    if(res.responseCode === 200){
                        this.$vs.notify({
                            title:'提示',
                            text: this.$t('message.sendSuccess'),
                            icon: 'done',
                            color:'success',
                            position:'top-center',
                            time: 3000
                        });
                        this.name = '';
                        this.email = '';
                        this.subject = '';
                        this.message = '';
                    }else{
                        this.$vs.notify({
                            title:'提示',
                            text: this.$t('message.errorMsg'),
                            icon: 'clear',
                            color:'danger',
                            position:'top-center',
                            time: 3000
                        });
                    }
                })
            }
        },
        components: {

        },
    }
</script>


<style>
    .card-con{
        padding: 20px;
    }

    .card-con .vs-con-input{
        margin-bottom: 15px;
    }

    .textArea{
        height: 200px;

    }

</style>
